import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield this.ready~}}\n<div class=\"liquid-sync\" {{this.setup}}></div>")